import React from 'react';
import TitleHashtag from './TitleHashtag';
import asyncComponent from '../../hoc/asyncComponent/asyncComponent';

// Style
import { st, classes } from './Hashtags.st.css';

const AsyncHashtagsGallery = asyncComponent(() => import('./hashtagsGallery'));

const Hashtags = () => (
  <div className={st(classes.root)}>
    <TitleHashtag />
    <AsyncHashtagsGallery />
  </div>
);

export default Hashtags;
